import React, { useState, useEffect, useContext } from "react";
import { Grid, Divider, Button, TextField } from "@material-ui/core";
import Input from "../../components/utils/Input";
import Select from "react-select";
import useStyles from "../../components/styles/styles";
import { postRequest } from "../../constant/ApiService";
import Api from "../../constant/Api";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import PageTitle from "../../components/PageTitle/PageTitle";
import { getRequest } from "../../constant/ApiService";
import { MainContext } from "../../context/MainContext";
import { DEGREEDRIVER } from "../../constant/staticData";

const DriverRegister = () => {
  const classes = useStyles();
  const history = useHistory();
  const [driverInfo, setDriverInfo] = useState();
  const [truckInfo, setTruckInfo] = useState();
  const [degreeDriver, setDegreeDriver] = useState({});

  const [registerInfo, setRegisterInfo] = useState({
    nationalId: "",
    smartCode: "",
    phone: "",
    truckId: 1,
    bargirId: 1,
    degreeId: 1,
    degreeName: "",
    max_Weight: 1
  });


  let {
    carrier,
    handleCarrierType,
    handleTruckType,
  } = useContext(MainContext);

  const degreeOption = () => {
    let handleOptions = DEGREEDRIVER.map(item => {
      return {
        value: item.value,
        label: item.label,
      };
    });
    setDegreeDriver(handleOptions);
  };

  useEffect(() => {
    handleCarrierType();
    handleTruckType();
    degreeOption();
  }, []);

  const getDriverInfo = () => {
    getRequest(
      `${Api.GetDriverInfo}?NationalId=${registerInfo.nationalId}`,
    ).then(res => {
      setDriverInfo(res && res.data);
    });

    getRequest(
      `${Api.GetTruckInfo}?SmartCode=${registerInfo.smartCode}`,
    ).then(res => {
      setTruckInfo(res && res.data);
    });
  };


  const getTruckInfo = () => {
    getRequest(
      `${Api.GetTruckInfo}?SmartCode=${registerInfo.smartCode}`,
    ).then(res => {
      setTruckInfo(res && res.data);
    });
  };



  const addNewCarrierDriverAndDriver = async () => {
    const body = {
      identityNumber: registerInfo.nationalId,
      navyNumber: registerInfo.smartCode,
      truckId: registerInfo.truckId.value,
      bargirId: registerInfo.bargirId.value,
      degreeId: registerInfo.degreeId.value,
      degreeName: registerInfo.degreeId.label,
      phone: registerInfo.phone,
      max_Weight: registerInfo.max_Weight
    };

    try {
      const res = await postRequest(Api.CreateDriverBySmartCode, body);
      if (res?.succeeded) {
        toast.success(res.message);
        history.push("/app/driversList");
      } else {
        toast.error("Failed to register driver.");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      console.error("API Error:", error);
    }
  };

  const ReadOnlyTextField = ({ label, value }) => (
    <Grid className={classes.colItem} item xl={4} lg={4} md={4} sm={12} xs={12}>
      <label>{label}</label>
      <TextField
        id="standard-read-only-input"
        defaultValue={value}
        variant="outlined"
        InputProps={{
          readOnly: true,
        }}
        fullWidth
      />
    </Grid>
  );

  return (
    <Grid container  >
      <PageTitle title="ثبت راننده" />

      <Grid container>
        <h3>مشخصات راننده</h3>
      </Grid>

      <Grid container  >
        <Grid className={classes.colItem}
          item
          xl={4}
          lg={4}
          md={4}
          sm={12}
          xs={12}>
          <label>شماره ملی</label>
          <Input
            name="nationalId"
            onChange={({ target }) =>
              setRegisterInfo(state => ({
                ...state,
                nationalId: target.value,
              }))
            }
            value={registerInfo.nationalId}
            type="number"
            fullWidth
          />
        </Grid>

        <Grid className={classes.colItem}
          item
          xl={4}
          lg={4}
          md={4}
          sm={12}
          xs={12}>
          <label>شماره ناوگان</label>
          <Input
            name="smartCode"
            onChange={({ target }) =>
              setRegisterInfo(state => ({
                ...state,
                smartCode: target.value,
              }))
            }
            value={registerInfo.smartCode}
            type="number"
            fullWidth
          />
        </Grid>

        {/* دکمه جستجو */}
        <Grid className={classes.colItem}
          item
          xl={4}
          lg={4}
          md={4}
          sm={12}
          xs={12}>
          <br />

          <Button
            variant="contained"
            style={{ color: "#fff", backgroundColor: "#3CD4A0" }}
            fullWidth
            onClick={getDriverInfo}

          >
            جستجو اطلاعات راننده
          </Button>
        </Grid>
        <Grid className={classes.colItem}
          item
          xl={4}
          lg={4}
          md={4}
          sm={12}
          xs={12}>

        </Grid>

      </Grid>

      <ReadOnlyTextField label="نام" value={driverInfo?.name} />
      <ReadOnlyTextField label="نام خانوادگی" value={driverInfo?.family} />
      <ReadOnlyTextField label="تاریخ تولد" value={driverInfo?.birtH_DATE} />
      <ReadOnlyTextField label="شماره ملی" value={driverInfo?.codE_MELI} />
      <ReadOnlyTextField label="شماره هوشمند" value={driverInfo?.nO_KART} />
      <ReadOnlyTextField label="شهر" value={driverInfo?.namE_SHOEBE} />
      <Grid
        className={classes.colItem}
        item
        xl={4}
        lg={4}
        md={4}
        sm={12}
        xs={12}
      >
        <label>مدرک تحصیلی</label>
        <Select
          onChange={e => setRegisterInfo({ ...registerInfo, degreeId: e })}
          options={degreeDriver}
          placeholder="مدرک تحصیلی را انتخاب کنید"
        />
      </Grid>
      <Divider style={{ width: "100%", margin: "10px 0" }} />

      <Grid container>
        <h3>مشخصات وسیله نقلیه</h3>
      </Grid>

      <Grid container  >
        <Grid
          className={classes.colItem}
          item
          xl={4}
          lg={4}
          md={4}
          sm={12}
          xs={12}
        >
          <label>بارگیر</label>
          <Select

            onChange={e => setRegisterInfo({ ...registerInfo, truckId: e })}
            options={carrier.truckType}
            value={registerInfo.truckId}
            placeholder="بارگیر را انتخاب کنید"
          />
        </Grid>
        <Grid
          className={classes.colItem}
          item
          xl={4}
          lg={4}
          md={4}
          sm={12}
          xs={12}
        >
          <label>نوع بارگیر</label>
          <Select
            onChange={e => setRegisterInfo({ ...registerInfo, bargirId: e })}
            options={carrier.carrierType}
            value={registerInfo.bargirId}
            placeholder="نوع بارگیر را انتخاب کنید"
          />
        </Grid>
        <Grid
          className={classes.colItem}
          item
          xl={4}
          lg={4}
          md={4}
          sm={12}
          xs={12}
        >
          <label>تلفن</label>
          <Input
            onChange={({ target }) =>
              setRegisterInfo(state => ({
                ...state,
                phone: target.value,
              }))
            }
            value={registerInfo.family}
            type="phone"
          />
        </Grid>

      </Grid>
      <ReadOnlyTextField label="شماره ناوگان" value={truckInfo?.nO_KART} />
      <ReadOnlyTextField label="نوع برند" value={truckInfo?.systeM_NAME} />
      <ReadOnlyTextField label="سال ساخت کامیون" value={truckInfo?.saL_SAKHT} />


      <Grid container justifyContent="flex-end" style={{ marginTop: 20 }}>
        <Button
          variant="contained"
          style={{ color: "#fff", backgroundColor: "#3CD4A0" }}
          onClick={addNewCarrierDriverAndDriver}
        >
          ثبت
        </Button>
      </Grid>
    </Grid>
  );
};

export default DriverRegister;